/**
 * Custom events for GTM
 */

(function (window, document, $, undefined) {
	'use strict';

	// override gtmHelper object, instead append to existing
    window.gtmHelper = window.gtmHelper || {};
	window.gtmHelperAppend = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			gtmHelper.initVars();
			gtmHelper.bind();
			gtmHelper.pageInit();
		},

		/**
		 * Setting and initializing all variables.
		 *
		 * @since 1.0.0
		 */
		initVars: function () {
			// Vars for Product Filter tracking
			gtmHelper.$productFilterSearchTimer = 1000;
		},

		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {
			// Carousel Events
			$( 'body' ).on( 'click', '.carousel-content-button', gtmHelper.carouselEvent );
			// Bind to document downloads
			$( 'body' ).on( 'click', '.document-download, .document-download-insight', gtmHelper.documentDownloadEvent );
			// Bind to Product page - Fund Chart Interactions
			$( 'body' ).on( 'click', '.fund-chart-name', gtmHelper.fundChartInteraction );
			// Bind to Product page - Risk Tabs event
			$( 'body' ).on( 'click', '.product_disclosure_container .risk-tab-name', gtmHelper.riskTabEvent );
			// Bind to Product page - Follow/Unfollow fund
			$( 'body' ).on( 'click', '.hero-content .btn-follow', gtmHelper.fundFollowEvent );
			// Bind to Product page - select Share class
			$( 'body' ).on( 'change', '.share-class-select', gtmHelper.shareClassEvent );
			// Bind to Category Tag clicks
			$( 'body ' ).on( 'click', '.post-categories a', gtmHelper.categoryTagEvent );
			// Bind to Category Tag clicks
			$( 'body ' ).on(
				'click',
				'.fl-module-cta .fl-cta-button, .insights-subscribe-filter .fl-button, .fl-module-button',
				gtmHelper.callToActionEvent
			);
			// Bind to Subscription Drawer Open event
            $('body').on('click', '#drawer-trigger-cta .template-subscription__submit-button', gtmHelper.subscriptionFormSubmitEvent);
			//Bind to Contact US page - Sales Director location filter events
			$( 'body' ).on( 'change', '#region-select', gtmHelper.salesDirectorLocationFilterEvent );
			//Bind to Contact US page - Office Map filter events
			$( 'body' ).on( 'change', '#locations-region', gtmHelper.officeMapFilterEvent );
			//Bind to Contact US page - Sales Team contact events
			$( 'body' ).on( 'click', '.contact-bio .email, .contact-bio .phone', gtmHelper.contactSalesTeamEvent );
			//Bind to In Page interaction events
			$( 'body' ).on( 'click', 'a[data-attr="in-Page-Event"]', gtmHelper.inPageInteractionEvent );
			//Bind to Audio events
			$( 'body' ).on( 'click', '.mejs-button', gtmHelper.audioEvent );
			// Product Filter - Search
			$( 'body' ).on( 
				'keyup', 
				'#product-search input[type=search]', 
				jh_custom.debounce( 
					function() {
			  			gtmHelper.productFilterSearch,
						gtmHelper.$productFilterSearchTimer
					}
				)
			);
			this.bindTabClickEvent();
			// Product Filter - Filter Category
			$( 'body' ).on( 'click', '#products-filter .filter_options :input', gtmHelper.productFilterSelected );
		},

		/**
		 *  ProductFilter - Search
		 *
		 * @since 1.0.0
		 */
		productFilterSearch: function () {
			gtmHelper.productFilterEvent( 'Search', $( "#product-search input[type=search]" ).val() );
		},

		/**
		 *  ProductFilter - Category filter events
		 *
		 * @since 1.0.0
		 */
		productFilterSelected: function () {
			if ( $( this ).is( ':checked' ) ) {
				gtmHelper.productFilterEvent(
					$( this ).closest( '.filter_widget' ).find( '.filter_title' ).text(),
					$.trim( $( this ).closest( 'label' ).clone().children().remove().end().text() )
				);
			}
		},

		/**
		 *  ProductFilter- Event Tracking
		 *
		 * @since 1.0.0
		 */
		productFilterEvent: function ( name, value ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' : 'product-table-filter',
					'product-table-filter' : {
						'name'  : name,
						'value' : value
					}
				}
			);
		},

		/**
		 *  Actions we want to perform on every page.
		 *
		 * @since 1.0.0
		 */
		pageInit: function () {
			// Add document-download class to pdf links if they don't already have it
			$( "a[href$='.pdf'], a[href$='.PDF'], a[href*='/document/'], a[href*='/documents/docId']" ).not( '.document-download' ).addClass( 'document-download' );

			// Add data-extension to service document links
			$( "a[href*='/documents/docId']" ).attr( 'data-extension', 'pdf' );
		},

		/**
		 *  Track buttons clicked within carousel slides
		 *
		 * @since 1.0.0
		 */
		carouselEvent: function () {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event': 'carousel-interaction',
					'carousel-interaction': {
						'clickURL': encodeURI($( this ).attr( 'href' )),
						'slideNumber': $( this ).data( 'slide-number' )
					}
				}
			);
		},

		/**
		 *  Track form submit events
		 *
		 * @since 1.0.0
		 */
		formSubmitEvent: function ( formName, status, message ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event'		  : 'form-submit',
					'form-submit' : {
						'name' 	  : formName,
						'status'  : status,
						'message' : message || undefined
					}
				}
			);
		},

		/**
		 *  Track form User login events
		 *
		 * @since 1.0.0
		 */
		userLoginEvent: function ( status, message ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event'			 : 'user-login',
					'login-register' : {
						'status'     : (status) ? 'Success' : 'Failure',
						'message' 	 : message || undefined
					},
					'userMeta' 		 : {
						'userId' 	 : global_data_layer.userId,
						'isInternal' : global_data_layer.isInternal
					}
				}
			);
		},

		/**
		 *  Track User Register event
		 *
		 * @since 1.0.0
		 */
		userRegisterEvent: function ( status, message ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 		 : 'user-register',
					'login-register' : {
						'status'     : ( status ) ? 'Success' : 'Failure',
						'message'    :   message || undefined
					},
					'userMeta'       : {
						'userId'     : global_data_layer.userId,
						'isInternal' : global_data_layer.isInternal
					}
				}
			);
		},

		/**
		 *  Track Fund Chart Interaction events
		 *
		 * @since 1.0.0
		 */
		fundChartInteraction: function ( chartName ) {
			if ( typeof chartName == 'string' ) {
				//get the 10k growth chart title
				chartName = $.trim( chartName );
			} else {
				//get the main title for morninigstar percentile - no need for other chart tables
				var chartTitle = $( this ).closest( '.mrg-perc' ).find( '.mrg-perc-title' ).text();
				//concate with tab-name chart tables
				chartName = $.trim( $.trim( chartTitle.replace( /[\t\n]+/g,' ' ) ) + ' ' + $.trim( $( this ).text() ) );
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	 : 'fund-chart-interaction',
					'fund-chart' : {
						'name'   : chartName,
					},
				}
			);
		},

		/**
		 *  Track Risk Tab events
		 *
		 * @since 1.0.0
		 */
		riskTabEvent: function ( ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 		  : 'risk-tab-action',
					'risk-tab-action' : {
						'name' 		  : $.trim( $( this ).text() ),
					},
				}
			);
		},

		/**
		 *  Track Fund Follow/Unfollow events
		 *
		 * @since 1.0.0
		 */
		fundFollowEvent: function ( ) {
			//This html text manipualation will be changed once Follow/Unfollow feature is added
			$( 'span.follow-text' ).html( $( "span.follow-text" ).html() == 'Follow' ? 'Unfollow' : 'Follow' );

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 		: 'fund-follow',
					'fund-follow'   : {
						'action'    : $.trim( $( this ).text() ),
					},
					'eventMeta' 	: {
						'fundName'  : global_data_layer.fundName,
						'fundClass' : global_data_layer.fundClass
					}
				}
			);
			window.dataLayer.push(
				{
					'eventMeta' 		: {
						'fundName' 		: undefined,
						'fundClass'		: undefined
					}
				}
			);
		},

		/**
		 *  Track Select Share Class events
		 *
		 * @since 1.0.0
		 */
		shareClassEvent: function ( ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 			 : 'select-share-class',
					'select-share-class' : {
						'name' 			 : $.trim( $( this ).find( 'option:selected' ).text() ),
					},
				}
			);
		},

		/**
		 *  Track Investment Insights Search/Filter events
		 *
		 * @since 1.0.0
		 */
		investmentInsightsEvent: function ( searchTerm, searchCat, assetClass, format, searchFilter ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 			  		 : 'investment-insights-filter',
					'investment-insights-filter' : {
						'query' 	  	  		 : searchTerm || undefined,
						'category'  	  		 : searchCat || undefined,
						'assetClass' 	  		 : assetClass || undefined,
						'format'  	    		 : format || undefined,
						'searchFilter' 	  		 : searchFilter || undefined,
					},
				}
			);
		},

		/**
		 *  Track Category Tag events
		 *
		 * @since 1.0.0
		 */
		categoryTagEvent: function ( ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	   : 'category-tag-click',
					'category-tag' : {
						'name' 	   : $.trim( $( this ).text() ),
					},
				}
			);
		},


        /**
         * Track Subscription Form Submit event
         *
         * @since 1.0.0
         */
        subscriptionFormSubmitEvent: function() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'subscription_form_submit',
                'subscription': {
                    'action': 'Form Submit'
                }
            });
        },

		/**
		 *  Track Call To Action event
		 *
		 * @since 1.0.0
		 */
		callToActionEvent: function ( ) {
			// Only if current class is not enclosed in carousel and not document download
			if ( ( ! $( this ).closest( ".carousel-caption" ).length ) &&
				( $( this ).find( 'a' ).attr( 'class' ).indexOf( 'document-download' ) === 0 ) ) {

				//Checking for either CTA text or headline when insights-subscription
				var headline = $.trim( $( this ).closest( ".fl-col" ).prev().find( ".fl-rich-text" ).text() );
				var ctaText  = $.trim( $( this ).find( '.fl-button-text' ).text() );

				//Checking for href URL
				var clickURL = $( this ).find( 'a' ).attr( 'href' ) || $( this ).attr( 'href' );

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push(
					{
						'event'			 : 'call-to-action',
						'call-to-action' : {
							'headline'   : ( headline.toLowerCase().indexOf( "subscribe" ) >= 0) ? headline : ctaText,
							'clickURL'   : encodeURI(clickURL) || undefined,
							'pageURL'	 : encodeURI(window.location.href)
						}
					}
				);
			}
		},

		/**
		 *  Track sales Director location filter events
		 *
		 * @since 1.0.0
		 */
		salesDirectorLocationFilterEvent: function ( ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	   			 		 : 'sales-director-location-filter',
					'sales-director-location-filter' : {
						'filter-selection'   		 : $.trim( $( this ).find( 'option:selected' ).text() ),
					},
				}
			);
		},

		/**
		 *  Track Office Map filter events
		 *
		 * @since 1.0.0
		 */
		officeMapFilterEvent: function ( ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	   			 : 'office-location-filter',
					'office-location-filter' : {
						'filter-selection'   : $.trim( $( this ).find( 'option:selected' ).text() ),
					},
				}
			);
		},

		/**
		 *  Track Sales Team contact events
		 *
		 * @since 1.0.0
		 */
		contactSalesTeamEvent: function ( ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	   		  : 'contact-sales-team',
					'contact-sales-team'  : {
						'contactName'	  : $( this ).closest( '.preview-text' ).find( '.article-title' ).text(),
						'contactTitle'    : $( this ).closest( '.preview-text' ).find( '.position' ).text(),
						'contactMethod'	  : ( 'phone' === $( this ).attr( "class" ) ) ? 'Telephone' : 'Email'
					},
				}
			);
		},

		/**
		 *  In Page Interaction - compare event type
		 *
		 * @since 1.0.0
		 */
		inPageInteractionTrack: function( name, elementType ) {
			// If current page is Choose your goals
			if ( global_data_layer.name === 'choose-your-goals' ) {
				gtmHelper.chooseYourGoalsEvent( name );
			} else {
				gtmHelper.inPageInteractionEvent( name, elementType );
			}
		},

		/**
		 *  Track Choose your goal events
		 *
		 * @since 1.0.0
		 */
		chooseYourGoalsEvent: function ( name ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 			: 'choose-your-goal',
					'choose-your-goal'	: {
						'name'			: name
					}
				}
			);

		},

		/**
		 *  Track In Page Interaction events
		 *
		 * @since 1.0.0
		 */
		inPageInteractionEvent: function ( name, elementType ) {
			var elementType, name, filterSection;
			//Sticky Nav
			if ( typeof name == 'string' ) {
				filterSection = elementType;
				name          = name;
			} else {
				elementType   = $.trim( $( this ).data( 'type' ) );
				filterSection = $.trim( $( this ).text() );
				if ( elementType.includes( 'Related-Insights' ) ) {
					//Related Insights - Read more event
					name = $.trim( $( this ).closest( '.related-insights-item' ).find( '.blog-title' ).text() );
				} else if ( elementType.includes( 'Share-Class-Facts' ) ) {
					//Share Class Facts - Toggle - Section Expansion event
					name          = $.trim( $( this ).text() );
					filterSection = 'Section Expansion'
				} else {
					//Latest Insights - Read more event
					name = $.trim( $( this ).closest( '.controls' ).prev().find( '.article-title' ).text() );
				}
			}

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event' 	   		   : 'in-page-interaction',
					'in-page-interaction'  : {
						'name'			   : name,
						'type' 			   : filterSection,
					},
				}
			);
		},

		/**
		 *  Get Audio events(play/pause/end)
		 *
		 * @since 1.0.0
		 */
		audioEvent: function ( ) {
			var url   = $( this ).closest( '.mejs-audio' ).find( '.wp-audio-shortcode' ).attr( "src" );
			var title = $.trim( $( this ).closest( '.mejs-audio' ).closest( '.fl-module' ).prev().find( '.fl-rich-text' ).text() );
			$.each(
				$( this ).attr( 'class' ).split( /\s+/ ),
				function(index, item) {
					if (item === 'mejs-play') {
						//Play event
						gtmHelper.trackAudioEvent( 'play', title, url );
					}
					if ( item === 'mejs-pause' ) {
						//Pause event
						gtmHelper.trackAudioEvent( 'pause', title, url );
					}
				}
			);
		},

		/*
		 Track audio player events
		 event audio
		 audio.action One of; play, pause or ended.
		 audio.title The title of the audio being played. This should be a user-friendly name where possible.
		 audio.url The URL of the audio file being played.
		 */
		trackAudioEvent: function( action, title, url ) {
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push(
				{
					'event': 'audio',
					'audio': {
						'action': action,
						'title': title,
						'url': url
					}
				}
			);
		},

		/**
		 *  Track document downloads
		 *
		 * @since 1.0.0
		 */
		documentDownloadEvent: function (e) {
			var url           = $( this ).attr( "href" );
			var fileExtension = $( this ).attr( "data-extension" ) || gtmHelper.getFileExtension( url ).toLowerCase();
			var name          = $( this ).attr( "data-name" ) || undefined;

			// doesn't include data-name as attribute -
			if ( ! name ) {
				if ( $.trim( $( this ).text().toLowerCase() ).includes( 'download' ) ) {
					name = $( this ).closest( 'div.fl-col-content' ).children( '.fl-rich-text' ).val();
					name = ( ! name ) ? name : $.trim( $( this ).text() );
				}
			}

			// Fall back to PDF Name if name is not set as a data-name attribute on the link.
			name = name || gtmHelper.getFileName( url );

			// If we don't have a name attribute, and we can't extract the name from the PDF then do not track.
			if (name == undefined && fileExtension != "pdf") {
				return;
			}

			var fundName  = global_data_layer.fundName;
			var fundClass = global_data_layer.fundClass;

			// Create the dataLayerObject for a later push onto dataLayer
			var dataLayerObject = {
				'event': 'document-download',
				'document-download': {
					'name': name,
					'url': url
				},
				'eventMeta': {
					'fundName': fundName || undefined, // or undefined
					'fundClass': fundClass || undefined, // or undefined
				}
			};

			// Check to ensure GTM is loaded, this will ensure e.preventDefault() doesn't block the URL change in case of GTM instance missing.
			if (window['google_tag_manager']) {

				window.dataLayer = window.dataLayer || [];

				if ($( this ).attr( "target" ) != "_blank") {
					e.preventDefault();

					dataLayerObject.eventCallback = function () {
						window.location = url;
					};

					dataLayerObject.eventTimeout = 2000;
				}

				window.dataLayer.push( dataLayerObject );
				window.dataLayer.push(
					{
						'eventMeta': {
							'fundName': undefined,
							'fundClass': undefined,
						}
					}
				);
			}
		},

		/**
		 *  Get the file extension of a document
		 *
		 * @since 1.0.0
		 */
		getFileExtension: function (filename) {
			filename = gtmHelper.removeQueryParam( filename );
			return filename.split( '.' ).pop();

		},

		/**
		 *  Get the file name of a document
		 *
		 * @since 1.0.0
		 */
		getFileName: function (url) {
			url      = gtmHelper.removeQueryParam( url );
			var name = url.substr( url.lastIndexOf( '/' ) + 1 );
			name     = name.replace( '.pdf', '' );
			name     = name.replace( /-/g, ' ' );
			name     = name.toLowerCase();
			return name;
		},

		/**
		 *  Get the file extension of a document
		 *
		 * @since 1.0.0
		 */
		removeQueryParam: function (url) {
			var urlParts = url.split( '?' );
			if (urlParts.length >= 2) {
				// Strip query param
				url = url.split( '?' )[0];
			}
			return url;
		},

		// Bind Tab Click Event
		bindTabClickEvent: function () {
			const tabs = document.querySelectorAll('.pp-tabs-label');
			tabs.forEach(tab => {
				tab.addEventListener('click', function () {
					const title = tab.querySelector('.pp-tab-title').textContent;
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push({
						'event': 'tab_click',
						'title': title
					});
				});
			});
		},
	}

	

    window.gtmHelper = $.extend({}, window.gtmHelper, window.gtmHelperAppend);
	gtmHelper.init();

})( window, document, jQuery );



// Bind MediaElement player - Tracking audio event(end) for Analytics
jQuery( document ).ready(
	function ($) {
		if ( $.fn.mediaelementplayer ) {
			$( "audio" ).mediaelementplayer(
				{
					success: function (mediaElement, domObject, player) {
						var title = $.trim( $( '.mejs-audio' ).closest( '.fl-module' ).prev().find( '.fl-rich-text' ).text() );
						var url   = mediaElement.src || undefined;
						mediaElement.addEventListener(
							'ended',
							function () {
								gtmHelper.trackAudioEvent( 'ended', title, url );
							}
						);
					}
				}
			);
		}
	}
);

/**
 * TODO: THE BELOW CODE IS FROM EN-US. WAITING TO SEE IF WE NEED TO PULL IT IN
 */


// 	// Bind subscription submission button
// 	$( '.subscription-submit' ).on( 'click', recordSubscriptionEvent );

// 	/*
// 	 event email-subscription
// 	 email-subscription.action Either; Subscribe or Unsubscribe depending on the interaction.
// 	 email-subscription.name The name of the email list that the user has subscribed/unsubscribed from.
// 	 */
// 	function recordSubscriptionEvent() {
// 		$( '.subscription-list' ).find( 'input:checkbox' ).each(
// 			function (index, target) {
// 				var $target    = $( target );
// 				var isChecked  = $target.is( ':checked' );
// 				var title      = $target.attr( 'data-title' );
// 				var subscribed = $target.attr( 'data-subscribed' );
// 				//post to GTM for tracking if the checked status has changed
// 				if (subscribed && isChecked.toString() != subscribed.toString()) {
// 					window.gtmDataLayer = window.gtmDataLayer || [];
// 					window.gtmDataLayer.push(
// 						{
// 							'event': 'email-subscription',
// 							'email-subscription': {
// 								'action': isChecked ? 'Subscribe' : 'Unsubscribe',
// 								'name': title
// 							}
// 						}
// 					);
// 				}
// 			}
// 		);
// 	}
//
